import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  RadioGroupForm,
  Heading,
} from "@ogt/ui";

export const COMPENSATION_TICKET = "compensation_ticket";
export const COMPENSATION_TAXI = "compensation_taxi";
export const COMPENSATION_CAR = "compensation_car";

export default function Compensation() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 50;
  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          if (values.compensation === COMPENSATION_TICKET) {
            navigate("/hur-vill-du-ha-ersattning");
          } else if (values.compensation === COMPENSATION_TAXI) {
            navigate("/ersattning-for-taxi");
          } else if (values.compensation === COMPENSATION_CAR) {
            navigate("/ersattning-for-bil");
          }
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          compensation: Yup.string().test(
            "at-least-one-radio-selected",
            "Vänligen välj ett svarsalternativ för att gå vidare till nästa steg",
            (value) => {
              return (
                value === COMPENSATION_TICKET ||
                value === COMPENSATION_TAXI ||
                value === COMPENSATION_CAR
              );
            }
          ),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading
                  progress={progress}
                  headingRef={h2Ref}
                  focusable
                  id="compensation"
                >
                  Vad önskar du ha ersättning för?
                </Heading>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <div className={errors.compensation ? "has-error" : ""}>
                  <RadioGroupForm
                    name="compensation"
                    ariaLabelledBy="compensation"
                    orientation="vertical"
                    variant="box"
                    options={[
                      {
                        id: "compensationTicket",
                        value: COMPENSATION_TICKET,
                        label:
                          "Jag vill ha ersättning av priset för en enkelbiljett",
                      },
                      {
                        id: "compensationTaxi",
                        value: COMPENSATION_TAXI,
                        label: "Jag vill ha ersättning för resa med taxi",
                      },
                      {
                        id: "compensationCar",
                        value: COMPENSATION_CAR,
                        label: "Jag vill ha ersättning för resa med bil",
                      },
                    ]}
                  />
                </div>
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button onClick={handleSubmitClick(formRef)} type="submit">
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
